<script setup lang="ts">
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js'
import { Line as LineChart } from 'vue-chartjs'
import { computed } from 'vue'
import { useStatsStore } from '@/stores/statsStore'
import { useI18n } from 'vue-i18n'

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler)

const { t } = useI18n()
const statsStore = useStatsStore()

// Computed property to get chart data from the store
const chartData = computed(() => {
  // Retrieve the selected key's data from the store
  const selectedData = statsStore.stats.get(statsStore.selectedKey)

  return {
    labels: selectedData?.labels || [],
    datasets: [
      {
        label: selectedData?.datasets?.[0]?.label || 'Planets',
        backgroundColor: 'rgba(75, 192, 192, 0.1)',
        borderColor: 'rgba(75, 192, 192, 0.6)',
        data: selectedData?.datasets?.[0]?.data || [],
        fill: true,
        tension: 0.3,
        pointRadius: 0
      }
    ]
  }
})

// Define chart options
const options = computed(() => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index' as const,
      intersect: false
    },
    scales: {
      y: {
        beginAtZero: true
      }
    },
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: false
      },
      tooltip: {
        enabled: true,
        mode: 'index' as const,
        intersect: false,
        displayColors: false,
        callbacks: {
          title: function (context: any) {
            return t('statistics.charts.day', { day: context[0].label })
          },
          label: function (context: any) {
            // Get postfix from translations using the selected key
            const suffix = t(`statistics.stats.${statsStore.selectedKey}.postfix`)
            const value = context.parsed.y

            // Format large numbers with commas
            const formattedValue = value.toLocaleString()
            return formattedValue + suffix
          }
        }
      }
    },
    animation: {
      duration: 0
    }
  }
})
</script>

<template>
    <LineChart :data="chartData" :options="options"/>
</template>

<style scoped lang="scss">

</style>
